import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RouterLinkFactory {
  /**
   * Navigate application to homepage.
   *
   * Homepage is main page (component), which is rendered after login.
   * It is always safe to redirect to homepage.
   */
  public homepage(): string[] {
    return ['/home'];
  }

  /**
   * Navigate application to dsahboard
   */
  public dashboard(): string[] {
    return ['/management', 'dashboard'];
  }

  /**
   * Navigate application to login.
   */
  public login(): string[] {
    return ['/login'];
  }

  /**
   * Navigate application to Children list.
   */
  public children(): string[] {
    return ['/management', 'children'];
  }

  /**
   * Navigate application to children add form.
   */
  public createChild(): string[] {
    return ['/management', 'children', 'new'];
  }

  /**
   * Navigate application to Children detail.
   */
  public childrenDetail(id: string): string[] {
    return ['/management', 'children', id];
  }

  /**
   * Navigate application to children edit form.
   */
  public editChild(id: string): string[] {
    return ['/management', 'children', id, 'edit'];
  }

  /**
   * Navigate application to child profile history page.
   */
  public childProfileHistory(id: string): string[] {
    return ['/management', 'children', id, 'profile-history'];
  }

  /**
   * Navigate application to children close relative add form.
   */
  public createCloseRelative(id: string): string[] {
    return ['/management', 'children', id, 'add-close-relative'];
  }

  /**
   * Navigate application to children edit form.
   */
  public editCloseRelative(id: string, closeRelativeId: string): string[] {
    return ['/management', 'children', id, 'edit-close-relative', closeRelativeId];
  }

  /**
   * Navigate application to children edit school counseling recommendations form.
   */
  public editChildSpzRecommendations(id: string): string[] {
    return ['/management', 'children', id, 'edit-spz-recommendations'];
  }

  /**
   * Navigate application to groups list.
   */
  public groups(): string[] {
    return ['/management', 'groups'];
  }

  /**
   * Navigate application to groups detail.
   */
  public groupsDetail(uuid: string): string[] {
    return ['/management', 'groups', uuid];
  }

  /**
   * Navigate application to groups add form.
   */
  public createGroup(): string[] {
    return ['/management', 'groups', 'new'];
  }

  /**
   * Navigate application to groups edit form.
   */
  public editGroup(uuid: string): string[] {
    return ['/management', 'groups', uuid, 'edit'];
  }

  /**
   * Navigate application to today's attendance.
   */
  public attendanceToday(): string[] {
    return ['/management', 'attendance', 'today'];
  }

  /**
   * Navigate application to overview's attendance.
   */
  public attendanceOverview(): string[] {
    return ['/management', 'attendance', 'overview'];
  }

  /**
   * Navigate application to gradebook list.
   */
  public gradebookList(): string[] {
    return ['/management', 'gradebook'];
  }

  /**
   * Navigate application to gradebook add form.
   */
  public createGradebook(): string[] {
    return ['/management', 'gradebook', 'new'];
  }

  /**
   * Navigate application to export-msmt page.
   */
  public exportMsmt(): string[] {
    return ['/management', 'export-msmt'];
  }

  /**
   * Navigate application to gradebook edit form.
   */
  public editGradebook(uuid: string): string[] {
    return ['/management', 'gradebook', uuid, 'edit'];
  }

  /**
   * Navigate application to gradebook list.
   */
  public announcementList(): string[] {
    return ['/management', 'announcement'];
  }

  /**
   * Navigate application to announcement add form.
   */
  public createAnnouncement(): string[] {
    return ['/management', 'announcement', 'new'];
  }

  /**
   * Navigate application to announcement edit form.
   */
  public editAnnouncement(id: string): string[] {
    return ['/management', 'announcement', id, 'edit'];
  }

  /**
   * Navigate application to help page.
   */
  public help(): string[] {
    return ['/management', 'help'];
  }

  /**
   * Navigate application to pap homepage.
   */
  public childrenPortfolioDashboard(): string[] {
    return ['/children-portfolio', 'dashboard'];
  }

  /**
   * Navigate application to children portfolio page.
   */
  public childrenPortfolio(): string[] {
    return ['/children-portfolio', 'portfolio'];
  }

  /**
   * Navigate application to children portfolio page.
   */
  public childrenPortfolioShipOfKnowledge(): string[] {
    return ['/children-portfolio', 'ship-of-knowledge'];
  }

  /** Navigate to child Koráb poznání – Vybarvovačka. */
  public childrenPortfolioKorabChild(childId: string): string[] {
    return ['/children-portfolio/portfolio', childId, 'korab'];
  }

  /** Navigate to class Koráb poznání – Vybarvovačka (without uuid → resolves the selected class). */
  public childrenPortfolioKorabClass(groupUuid?: string): string[] {
    return ['/children-portfolio', 'class', 'korab', ...(groupUuid ? [groupUuid] : [])];
  }

  /** Navigate to Lodní deník – Třídnice (without uuid → resolves the selected class). */
  public childrenPortfolioClassDiary(groupUuid?: string): string[] {
    return ['/children-portfolio', 'class', 'diary', ...(groupUuid ? [groupUuid] : [])];
  }

  /** Navigate to the Třídnice editor of one day (date = YYYY-MM-DD). */
  public childrenPortfolioClassDiaryEditor(groupUuid: string, date: string): string[] {
    return ['/children-portfolio', 'class', 'diary', groupUuid, date];
  }

  /**
   * Navigate application to children portfolio competence page.
   */
  public childrenPortfolioSkill(): string[] {
    return ['/children-portfolio', 'skill'];
  }

  /**
   * Navigate application to children portfolio competence page.
   */
  public childrenPortfolioCompetence(): string[] {
    return ['/children-portfolio', 'competence'];
  }

  /**
   * Navigate application to children portfolio literacy page.
   */
  public childrenPortfolioLiteracy(): string[] {
    return ['/children-portfolio', 'literacy'];
  }

  /**
   * Navigate application to children portfolio activity page.
   */
  public childrenPortfolioActivity(): string[] {
    return ['/children-portfolio', 'activity'];
  }

  /**
   * Navigate application to children portfolio detail.
   */
  public childrenPortfolioDetail(childId: string): string[] {
    return ['/children-portfolio/portfolio', childId];
  }

  /** Navigate to the child's Lodní deník tab (POR-001-04). */
  public childrenPortfolioDetailShipLog(childId: string): string[] {
    return ['/children-portfolio/portfolio', childId, 'ship-log'];
  }

  /**
   * Navigate application to children skill detail.
   */
  public childrenPortfolioDetailSkill(childId: string): string[] {
    return ['/children-portfolio/portfolio', childId, 'skill'];
  }

  /**
   * Navigate application to children competence detail.
   */
  public childrenPortfolioDetailCompetence(childId: string): string[] {
    return ['/children-portfolio/portfolio', childId, 'competence'];
  }

  /**
   * Navigate application to children timeline detail.
   */
  public childrenPortfolioDetailTimeline(childId: string): string[] {
    return ['/children-portfolio/portfolio', childId, 'timeline'];
  }

  /**
   * Navigate application to pap portfolio page.
   */
  public papPortfolio(): string[] {
    return ['/pap', 'portfolio'];
  }

  /**
   * Navigate application to pap portfolio detail page.
   */
  public papPortfolioDetail(id: string): string[] {
    return ['/pap', 'portfolio', id];
  }

  /**
   * Navigate application to pap plan page.
   */
  public papPlan(): string[] {
    return ['/pap', 'plan'];
  }

  /**
   * Navigate application to pap plan detail page.
   */
  public papPlanDetail(id: string): string[] {
    return ['/pap', 'plan', id];
  }

  /**
   * Navigate application to pap auto evaluation page.
   */
  public papAutoEvaluation(): string[] {
    return ['/pap', 'auto-evaluation'];
  }

  /**
   * Navigate application to classroom
   */
  public group(groupId: string): string[] {
    return ['/management', 'groups', groupId];
  }

  /**
   * Navigate application to first subpage of the settings.
   */
  public settings(): string[] {
    return ['/settings'];
  }

  /**
   * Navigate application to holidays dates page.
   */
  public holidaysDates(): string[] {
    return ['/settings', 'holidays-dates'];
  }

  /**
   * Navigate application to holidays dates add form.
   */
  public createHolidaysDates(): string[] {
    return ['/settings', 'holidays-dates', 'new'];
  }

  /**
   * Navigate application to holidays dates edit form.
   */
  public editHolidaysDates(uuid: string): string[] {
    return ['/settings', 'holidays-dates', uuid, 'edit'];
  }

  /**
   * Navigate application to kindergarten-data page.
   */
  public kindergartenData(): string[] {
    return ['/settings', 'kindergarten-data'];
  }

  /**
   * Navigate application to organization workplaces page.
   */
  public organizationWorkplaces(): string[] {
    return ['/settings', 'organizace-a-licence'];
  }

  /**
   * Navigate application to prices page.
   */
  public priceList(): string[] {
    return ['/settings', 'price-list'];
  }

  /**
   * Navigate application to change password page.
   *
   */
  public changePassword(): string[] {
    return ['/settings', 'user', 'change-password'];
  }

  /**
   * Navigate application to add user page.
   *
   */
  public addUser(): string[] {
    return ['/settings', 'user', 'list', 'add-user'];
  }

  /**
   * Navigate application to add user page.
   *
   */
  public editUser(id: string): string[] {
    return ['/settings', 'user', 'list', 'edit-user', id];
  }

  /**
   * Navigate application to user list page.
   *
   */
  public userList(): string[] {
    return ['/settings', 'user', 'list'];
  }

  public userInvite(): string[] {
    return ['/settings', 'user', 'invite'];
  }

  /**
   * Navigate application to enrollment page.
   */
  public enrollment(): string[] {
    return ['/settings', 'enrollment'];
  }
  /**
   * Navigate application signup (registration).
   */
  public signup(): string[] {
    return ['/signup'];
  }
  /**
   * Navigate application to email verification.
   */
  public emailVerification(): string[] {
    return ['/signup', 'verify-email'];
  }
  /**
   * Navigate application to phone number verification.
   */
  public phoneVerification(): string[] {
    return ['/verification', 'phone'];
  }
}
